import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft, Plus } from 'lucide-react'
import FlowConfigManager from '../components/FlowConfigManager'

const FlowManagement: React.FC = () => {
  const navigate = useNavigate()
  const [isEditing, setIsEditing] = useState(false)

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center space-x-4">
              <button
                onClick={() => navigate('/templates/management')}
                className="p-2 hover:bg-gray-200 rounded-lg"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-3xl font-bold text-gray-900">
                  Gerenciar Fluxos
                </h1>
                <p className="text-gray-600">Configure e gerencie fluxos de conversa automatizados</p>
              </div>
            </div>
            {!isEditing && (
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => {
                    // Trigger create flow - we'll need to pass this to FlowConfigManager
                    const event = new CustomEvent('createFlow')
                    window.dispatchEvent(event)
                  }}
                  className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  <Plus className="w-4 h-4" />
                  <span>Novo Fluxo</span>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <FlowConfigManager 
          onClose={() => navigate('/templates/management')} 
          onEditingChange={setIsEditing}
        />
      </div>
    </div>
  )
}

export default FlowManagement
